module.exports = __webpack_public_path__ + "static/media/GoogleSans-Regular.411def33.ttf";